<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <section class="sell_your_device_dashboard_default text-center">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width':'100%'}">
                    <div class="row">
                        <Sidebar></Sidebar>
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mb-4 cat-block-device">
                            <div class="container-fluid">
                                
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h2 class="text-left dashboard-menus-heading" style="border-bottom: 2px dashed #28a74538; font-family: Ubuntu; color: #28A745;"><i class="fa fa-cart-arrow-down" aria-hidden="true"></i> Sell Orders Info </h2>
                                        </div>
                                    </div>
                                    <div class = "row">
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <span class="fa fa-shopping-cart"></span>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> All Sell Item </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.totalInvoice }} Items </h2>
                                                        <a @click="sellOrder()" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <!-- <span class="fa fa-money" aria-hidden="true"></span> -->
                                                        <i class="fas fa-money-bill-alt"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Sell Paid </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.totalPaidInvoice }} Items </h2>
                                                        <router-link to="/user/order/paid" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fas fa-exchange-alt"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Sell In-Progress </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.totalPendingInvoice }} Items </h2>
                                                        <router-link to="/user/order/in-progress" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fas fa-cut"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Sell Cancel </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.totalCancelInvoice}} Items </h2>
                                                        <router-link to="/user/order/cancel" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fa fa-ban" aria-hidden="true"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Sell Rejected </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{dashboardData.totalRejectedInvoice}} Items </h2>
                                                        <router-link to="/user/order/rejected" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h2 class="text-left dashboard-menus-heading" style="border-bottom: 2px dashed #28a74538; font-family: Ubuntu; color: #28A745;"><i class="fa fa-shopping-basket" aria-hidden="true"></i> Purchase Orders Info </h2>
                                        </div>
                                    </div>
                                    <div class = "row">
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <span class="fa fa-shopping-cart"></span>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> All Purchase Items </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.purchaseTotalInvoice }} Items </h2>
                                                        <a @click="purchaseOrder()" title="Style Builder" class="anchor btn btn-default" style="color: #fff; background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fa fa-money" aria-hidden="true"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Purchase Paid Order </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.purchaseTotalPaidInvoice }} Items </h2>
                                                        <router-link to="/purchase/order/paid" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fa fa-exchange" aria-hidden="true"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Order In-Progress </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.purchaseTotalInProgressInvoice }} Items </h2>
                                                        <router-link to="/purchase/order/in-progress" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fa fa-scissors" aria-hidden="true"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Purchase Cancel Order </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.purchaseTotalCancelInvoice }} Items </h2>
                                                        <router-link to="/purchase/order/cancel" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                        <div class = "col-md-4 mb-4">
                                            <div class="card-base">
                                                <div class="card-icon">
                                                    <a href="#" title="Widgets" id="widgetCardIcon" class="imagecard">
                                                        <i class="fa fa-ban" aria-hidden="true"></i>
                                                    </a>
                                                    <div class="card-data widgetCardData">
                                                        <h2 class="box-title main-box-title mt-4 pt-4" style="color: #28A745; font-weight: 600; font-family: 'Ubuntu';"> Purchase Rejected Order </h2>
                                                        <h2 class="box-title" style="color: #28A745; font-size: 20px; font-family: 'Font Awesome 5 Free';"> {{ dashboardData.purchaseTotalRejectedInvoice }} Items </h2>
                                                        <router-link to="/purchase/order/reject" title="Style Builder" class="anchor btn btn-default" style="background: rgb(85 95 87 / 78%); border: rgb(40, 167, 69);">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i> Explore Detail
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="space"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import Sidebar from "../layout/Sidebar.vue";
    import {authHeader} from "../../auth";

    export default {
        name: "DashboardComponent",
        components: {
            Sidebar,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                loader: "bars",
                dashboardData: [],
            }
        },
        created() {
            document.title = 'Geek Buy Back - Dashboard';
            this.getDashboardData();
        },
        methods: {
            getDashboardData: function() {
                this.isLoading = true;
                var config = {
                    method: "GET",
                    url: this.$api + this.$config.dashboard.dashboardURL,
                    headers: authHeader()
                };
                this.$axios(config).then(response => {
                    this.dashboardData = response.data;
                    this.isLoading = false;
                }).catch(e => {
                    console.log(e);
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again!"
                    });

                    this.$router.push({
                        name: 'Login'
                    });

                });   
            },
            purchaseOrder: function() {
                this.$router.push({
                    name: 'PurchaseOrder'
                });
            },
            sellOrder: function() { 
                this.$router.push({
                    name: 'SellOrder'
                });  
            },
        },
    }
</script>

<style src="./css/common.css"></style>
